export default __webpack_public_path__ + "images/nVent-featured-news.jpg?31eb44f4e90c5b2f2938d46144bb257d";